import { Navigate, useParams } from "react-router-dom";
import { normalizeReferralCode, persistReferralCode } from "../utils/referral";

export default function ReferralRedirectPage() {
  const { code = "" } = useParams();
  const normalized = normalizeReferralCode(code);
  if (!normalized) return <Navigate to="/mint" replace />;
  persistReferralCode(normalized);
  return <Navigate to={`/mint?ref=${encodeURIComponent(normalized)}`} replace />;
}
